var flyoutMagicTriangle;

flyoutMagicTriangle = require('./flyout_magic_triangle');

module.exports = {
  init: function() {
    var $firstLink, $goodsTab, $menuElem, $nestedLinks, flyoutInstance, flyoutOpts;
    $goodsTab = $('#subnav-goods-tab');
    if (!($menuElem = $goodsTab.find('.ls-gcx-flyout-menu')).length) {
      return;
    }
    flyoutOpts = {
      $menuElem: $menuElem,
      rowSelector: '.ls-gcx-flyout-nested-links',
      delay: 200,
      onActivateRow: function(elem) {
        return $(elem).addClass('ls-gcx-flyout-active');
      },
      onDeactivateRow: function(elem) {
        return $(elem).removeClass('ls-gcx-flyout-active');
      }
    };
    $('.ls-gcx-flyout-category-image').lazyload({
      container: '#goods-tab',
      event: 'mouseover',
      performantScroll: true,
      skip_initial_check: true,
      skip_invisible: false
    });
    flyoutInstance = flyoutMagicTriangle(flyoutOpts);
    if (!flyoutInstance) {
      return;
    }
    $nestedLinks = $menuElem.find('.ls-gcx-flyout-nested-links');
    $nestedLinks.on('tap', function(e) {
      e.stopPropagation();
      return flyoutInstance.activateRow($(e.currentTarget));
    });
    $firstLink = $nestedLinks.first();
    return $goodsTab.bind('tab:active', function() {
      return flyoutInstance.activateRow($firstLink);
    });
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9tb2R1bGVzL2dpZ19ib2R5L2hlYWRlci9zdWJfbmF2L2Zyb250ZW5kL2luaXRfZmx5b3V0LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvbW9kdWxlcy9naWdfYm9keS9oZWFkZXIvc3ViX25hdi9mcm9udGVuZC9pbml0X2ZseW91dC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxtQkFBQSxHQUFzQixPQUFBLENBQVEseUJBQVI7O0FBRXRCLE1BQU0sQ0FBQyxPQUFQLEdBQ0U7RUFBQSxJQUFBLEVBQU0sU0FBQTtBQUNKLFFBQUE7SUFBQSxTQUFBLEdBQVksQ0FBQSxDQUFFLG1CQUFGO0lBQ1osSUFBQSxDQUFjLENBQUMsU0FBQSxHQUFZLFNBQVMsQ0FBQyxJQUFWLENBQWUscUJBQWYsQ0FBYixDQUFtRCxDQUFDLE1BQWxFO0FBQUEsYUFBQTs7SUFFQSxVQUFBLEdBQWE7TUFDWCxXQUFBLFNBRFc7TUFFWCxXQUFBLEVBQWEsNkJBRkY7TUFHWCxLQUFBLEVBQU8sR0FISTtNQUlYLGFBQUEsRUFBZSxTQUFDLElBQUQ7ZUFDYixDQUFBLENBQUUsSUFBRixDQUFPLENBQUMsUUFBUixDQUFpQixzQkFBakI7TUFEYSxDQUpKO01BTVgsZUFBQSxFQUFpQixTQUFDLElBQUQ7ZUFDZixDQUFBLENBQUUsSUFBRixDQUFPLENBQUMsV0FBUixDQUFvQixzQkFBcEI7TUFEZSxDQU5OOztJQVdiLENBQUEsQ0FBRSwrQkFBRixDQUFrQyxDQUFDLFFBQW5DLENBQ0U7TUFBQSxTQUFBLEVBQVcsWUFBWDtNQUNBLEtBQUEsRUFBTyxXQURQO01BRUEsZ0JBQUEsRUFBa0IsSUFGbEI7TUFHQSxrQkFBQSxFQUFvQixJQUhwQjtNQUlBLGNBQUEsRUFBZ0IsS0FKaEI7S0FERjtJQU9BLGNBQUEsR0FBaUIsbUJBQUEsQ0FBb0IsVUFBcEI7SUFFakIsSUFBQSxDQUFjLGNBQWQ7QUFBQSxhQUFBOztJQUVBLFlBQUEsR0FBZSxTQUFTLENBQUMsSUFBVixDQUFlLDZCQUFmO0lBQ2YsWUFBWSxDQUFDLEVBQWIsQ0FBZ0IsS0FBaEIsRUFBdUIsU0FBQyxDQUFEO01BQ3JCLENBQUMsQ0FBQyxlQUFGLENBQUE7YUFDQSxjQUFjLENBQUMsV0FBZixDQUEyQixDQUFBLENBQUUsQ0FBQyxDQUFDLGFBQUosQ0FBM0I7SUFGcUIsQ0FBdkI7SUFJQSxVQUFBLEdBQWEsWUFBWSxDQUFDLEtBQWIsQ0FBQTtXQUViLFNBQVMsQ0FBQyxJQUFWLENBQWUsWUFBZixFQUE2QixTQUFBO2FBQzNCLGNBQWMsQ0FBQyxXQUFmLENBQTJCLFVBQTNCO0lBRDJCLENBQTdCO0VBakNJLENBQU4ifQ==
